import { useState, useEffect, useRef } from "react";

declare global {
  var __TEST_MEDIA_QUERY_MATCHES__: Record<string, boolean> | undefined;
}

function getTestMediaQueryMatch(query: string) {
  return globalThis.__TEST_MEDIA_QUERY_MATCHES__?.[query];
}

export function useMediaQuery(query: string): boolean {
  const testMatchRef = useRef(getTestMediaQueryMatch(query));
  const [matches, setMatches] = useState(
    () => testMatchRef.current ?? window.matchMedia(query).matches,
  );

  useEffect(() => {
    const testMatch = testMatchRef.current;
    if (typeof testMatch === "boolean") {
      setMatches(testMatch);
      return;
    }

    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);

  return matches;
}
